exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sphere {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  background-color: #e98300;\n  border-radius: 50%;\n  color: #FFF;\n  font-size: 22px;\n  line-height: 20px;\n  height: 125px;\n  width: 125px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/philips-marks/orange-sphere/orange-sphere.component.scss
// module id = ../../../../../src/app/components/philips-marks/orange-sphere/orange-sphere.component.scss
// module chunks = main